export default __webpack_public_path__ + "static/media/MaxLogo.af309c99.png";